import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Tooltip } from "primereact/tooltip";
import { Paginator } from "primereact/paginator";
import { addDateTime } from "../../../../common/date-time";

import "./RESECommandCreateJob.scss";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";

import {
	getRESECommandDivisionDetailsInit,
	resepostCreateJobInit,
	resetCloneJobDetails,
	resetCreateJobSuccessMessage,
	resetRESEModifyJobDetails,
} from "../redux/actions";

import { Chip } from "primereact/chip";
import { Dialog } from "primereact/dialog";

const RESECommandCreateJob = () => {
	const resemodifyJobDetails = useSelector(
		(state) => state.reseCommand.setRESEModifyJobDetails
	);

	const resecloneJobDetails = useSelector(
		(state) => state.reseCommand.setCloneJobDetails
	);

	const history = useHistory();

	const toastRef = useRef();
	const createJobBtnRef = useRef(null);

	const serviceList = [
		//{ label: "grafana-agent", value: "grafana-agent" },
		{ label: "rese-agent", value: "rese-agent" },
		//{ label: "grafana-agent", value: "grafana-agent" },
		// {
		// 	label: "grafana-agent-linux",
		// 	value: "grafana-agent-linux",
		// },
		// {
		// 	label: "grafana-agent-windows",
		// 	value: "grafana-agent-windows",
		// },
	];

	const [availableServices, setAvailableServices] = useState(serviceList);

	const [firstTimeRendering, setFirstTimeRendering] = useState(false);

	const [division, setDivision] = useState(null); //division dropdown

	const [storeSelectionList, setStoreSelectionList] = useState(null); //render store
	const [service, setService] = useState(); //multiselect

	const [selectedServerType, setSelectedServerType] = useState(null); //multiselect
	const [selectedDateTime, setSelectedDateTime] = useState(null);

	const [selectedCommand, setSelectedCommand] = useState("Start (Set Automatic)");
	const [ritNumber, setRitNumber] = useState("");
	const [forceUpdate, setForceUpdate] = useState(false);
	const [selectedJobInfo, setSelectedJobInfo] = useState(null);
	const [showExistingJobInfoDialog, setShowExistingJobInfoDialog] =
		useState(false);
	const [showConfirmPopUp, setShowConfirmPopUp] = useState(false);

	const [jobPayload, setJobPayload] = useState(null);

	const [enteredStoreNumber, setEnteredStoreNumber] = useState(null);
	const [jobId, setJobId] = useState(null);
	const [jobType, setJobType] = useState(null);
	const [isModelContainerExpanded, setIsModelContainerExpanded] =
		useState(true);
	const [legendContainer, setLegendContainer] = useState(false);
	const [first, setFirst] = useState(0);
	const [rows, setRows] = useState(100);

	const storeRowRefs = useRef({});
	const searchInputRef = useRef(null);

	const divisionList = useSelector(
		(state) => state.reseCommand.divisionDetails.divStoreServerList
	);

	const serverTypeList = useSelector(
		(state) => state.reseCommand.divisionDetails.serverTypes
	); //multiselect

	const dispatch = useDispatch();
	const createJobSuccessMessage = useSelector(
		(state) => state.reseCommand.createJobSuccessMessage
	);

	/**
	 * Get Division and serverType details
	 */
	useEffect(() => {
		if (!divisionList && !serverTypeList) {
			dispatch(getRESECommandDivisionDetailsInit());
		} else {
			setDivision([...divisionList]);
			setFirstTimeRendering(true);
		}
	}, [divisionList, serverTypeList, dispatch]);

	useEffect(() => {
		if (division && !resemodifyJobDetails && !resecloneJobDetails) {
			fetchStores();
		}
	}, [division, dispatch]);

	useEffect(() => {
		if (firstTimeRendering && !resemodifyJobDetails && !resecloneJobDetails) {
			fetchStores();
		}
		if (firstTimeRendering && !!resemodifyJobDetails) {
			initializeModifyJobDetails(resemodifyJobDetails);
		}
		if (firstTimeRendering && !!resecloneJobDetails) {
			initializeCloneJobDetails(resecloneJobDetails);
		}
	}, [
		firstTimeRendering,
		// division,
		resemodifyJobDetails,
		resecloneJobDetails,
		dispatch,
	]);

	useEffect(() => {
			setAvailableServices(serviceList);
			setService([serviceList[0].value]);	
	}, [selectedServerType]);

	const navigateToJobDetails = () => {
		setTimeout(() => {
			history.push("/admin/rese/rese-agent/job-details");
		}, 3000);
	};

		/**
 Get Stores based on division
 */
 const fetchStores = () => {
	const storeList = {};
	if (division && division.length > 0) {
		division.forEach((divinfo) => {
			if (
				!!divinfo.stores &&
				divinfo.stores.length > 0
				) {
					divinfo.stores.forEach((storeInfo) => {
						const store = storeInfo
						if (!storeList[store]) {
							storeList[store] = {
								division: divinfo.division,
								isSelected: false,
						};
				}

					});

			}
		}
	);
	}
	setStoreSelectionList(storeList);
	console.log("storelist",storeList);
};

	/**
	 * Map backend command value to the UI dropdown label.
	 * Backend stores "Update" while the dropdown displays "Install / Update".
	 */
	const mapCommandFromBackend = (command) =>
		command === "Update" ? "Install / Update" : command;

	/**
	 * modify and clone job functions
	 */
	const initializeModifyJobDetails = (resemodifyJobDetails) => {
		const {
			jobId,
			jobType,
			division,
			selectedStore,
			serverTypes,
			serviceTypes,
			command,
			scheduledDateTime,
			ritNumber,
		} = resemodifyJobDetails;

		if (selectedStore && selectedStore.length > 0) {
			setJobId(jobId);
			const selectedDivision = getSelectedDivision(division);
			setDivision(selectedDivision);
			const storeList = getStoreList(selectedDivision, selectedStore);
			setStoreSelectionList(storeList);
		}

		setSelectedServerType(serverTypes);
		setService(serviceTypes);
		setJobType(jobType);
		setSelectedDateTime(new Date(scheduledDateTime));
		setSelectedCommand(mapCommandFromBackend(command));
		setRitNumber(ritNumber);
		setForceUpdate(false);
	};

	const initializeCloneJobDetails = (resecloneJobDetails) => {
		const {
			division,
			selectedStore,
			serverTypes,
			serviceTypes,
			command,
		} = resecloneJobDetails;

		const selectedDivision = getSelectedDivision(division);
		setDivision(selectedDivision);
		const storeList = getStoreList(selectedDivision, selectedStore);
		setStoreSelectionList(storeList);
		setSelectedServerType(serverTypes);
		setService(serviceTypes);
		setSelectedCommand(mapCommandFromBackend(command));
	};

	const getSelectedDivision = (division) => {
		const divisions = division.split(",");
		return divisionList.filter((div) => divisions.includes(div.division));
	};

	const getStoreList = (selectedDivision, selectedStore) => {
		const storeList = {};
		selectedDivision.forEach((divinfo) => {
			if (divinfo.stores && divinfo.stores.length > 0) {
				divinfo.stores.forEach((storeInfo) => {
					const store = storeInfo;
					if (!storeList[store]) {
						storeList[store] = {
							division: divinfo.division,
							isSelected: selectedStore.includes(store),
							//includedServerType: storeInfo.includedServerTypes || [],
							//excludedServerType: storeInfo.excludedServerTypes || [],
						};
					} else {
						storeList[store].isSelected = selectedStore.includes(store);
					}
				});
			}
		});
		return storeList;
	};

	/**
	 *
	 * Update selection for all stores at once
	 * @param {boolean} value - true/false
	 */
	const handleAllStoreSelection = (value) => {
		const storeList = { ...storeSelectionList };
		Object.keys(storeList).forEach((store) => {
			storeList[store].isSelected = value;
		});

		setStoreSelectionList({ ...storeList });
		if (!value) {
			setSelectedServerType(null);
			setEnteredStoreNumber(null);
		}
	};

	/**
	 * Select/Unselect store on clicking
	 * @param {string} store - Store Number
	 */
	const handleStoreButtonClick = (store) => {
		setStoreSelectionList((prevStoreList) => {
			const storeList = { ...prevStoreList };
			storeList[store] = {
				...storeList[store],
				isSelected: !prevStoreList[store].isSelected,
			};

			//Clear the entered number when the store is selected
			if (storeList[store].isSelected) {
				setEnteredStoreNumber(null);
			}
			//clear selected server types only of the last store is being unselected

			if (
				!storeList[store].isSelected &&
				Object.keys(storeList).filter(
					(store) => storeList[store].isSelected
				).length === 0
			) {
				setSelectedServerType(null);
			}
			return storeList;
		});
	};

	useEffect(() => {
		if (createJobSuccessMessage) {
			if (
				createJobSuccessMessage.includes(
					"Created scheduled job successfully"
				)
			) {
				toastRef.current.show({
					severity: "success",
					summary: "Success",
					detail: "Job created successfully.",
					life: 3000,
				});

				dispatch(resetCreateJobSuccessMessage());
				dispatch(resetCloneJobDetails());
				resetSelections();
				navigateToJobDetails();
			} else if (
				createJobSuccessMessage.includes("Modified job successfully")
			) {
				toastRef.current.show({
					severity: "success",
					summary: "Success",
					detail: "Job modified successfully.",
					life: 3000,
				});
				dispatch(resetCreateJobSuccessMessage());
				dispatch(resetRESEModifyJobDetails());
				resetSelections();
				navigateToJobDetails();
			} else if (
				createJobSuccessMessage.includes("Job Execution started")
			) {
				toastRef.current.show({
					severity: "success",
					summary: "Success",
					detail: "Job Execution started",
					life: 3000,
				});
				dispatch(resetCreateJobSuccessMessage());
				dispatch(resetCloneJobDetails());
				resetSelections();
				navigateToJobDetails();
			} else if (createJobSuccessMessage.includes("Job Accepted")) {
				toastRef.current.show({
					severity: "success",
					summary: "Success",
					detail: "Job Accepted.",
					life: 3000,
				});
				dispatch(resetCreateJobSuccessMessage());
				dispatch(resetCloneJobDetails());
				resetSelections();
				navigateToJobDetails();
			} else {
				const jobIds = createJobSuccessMessage.map(
					(job) => (job.jobData.match(/job-(\d+)/) || [])[0]
				);
				confirmPopup({
					target: createJobBtnRef.current,
					message: (
						<div>
							<div>Job already exists.</div>
							{jobIds.length > 0 && (
								<div>
									Job Ids:{" "}
									{jobIds.map((jobId, index) => (
										<React.Fragment key={jobId}>
											<a
												href={`#${jobId}`}
												onClick={(e) => {
													e.preventDefault();
													const selectedJob =
														createJobSuccessMessage.find(
															(job) =>
																job.jobData.includes(
																	jobId
																)
														);
													setSelectedJobInfo(
														selectedJob
													);
													setShowExistingJobInfoDialog(
														true
													);
													setShowConfirmPopUp(false);
												}}
											>
												{jobId}
											</a>
											{index < jobIds.length - 1
												? ", "
												: ""}
										</React.Fragment>
									))}
								</div>
							)}
							<div>Do you still wish to continue?</div>
						</div>
					),
					accept: () => {
						dispatch(
							resepostCreateJobInit({
								...jobPayload,
								forceUpdate: true,
							})
						);

						dispatch(resetCreateJobSuccessMessage());
						setShowConfirmPopUp(false);
					},
					reject: () => {
						resetSelections();
						dispatch(resetCreateJobSuccessMessage());
						dispatch(resetRESEModifyJobDetails());
						dispatch(resetCloneJobDetails());
						setShowConfirmPopUp(false);
					},
				});
			}
		}
	}, [createJobSuccessMessage, dispatch]);

	const resetSelections = () => {
		setSelectedServerType(null);
		setService(null);
		setAvailableServices(null);
		setSelectedCommand(null);
		setSelectedDateTime(null);
		setDivision([...divisionList]);
		setEnteredStoreNumber(null);
		setJobType(null);
		setRitNumber("");

		const resetStoreSelectionList = { ...storeSelectionList };
		Object.keys(resetStoreSelectionList).forEach((store) => {
			resetStoreSelectionList[store].isSelected = false;
		});
		setStoreSelectionList(resetStoreSelectionList);
	};

	const handleCreateJob = async (e) => {
		const validationChecks = [
			{
				condition: !division,
				message: "Please select division.",
			},
			{
				condition: !Object.keys(storeSelectionList || {}).some(
					(store) => storeSelectionList[store].isSelected
				),
				message: "Please select store(s).",
			},
			{
				condition: !service || service.length === 0,
				message: "Please select service(s).",
			},
			{
				condition: !selectedCommand,
				message: "Please select command.",
			},
			{
				condition: !selectedDateTime && jobType === "Scheduled",
				message: "Please select date and time.",
			},
			// {
			// 	condition: !ritNumber,
			// 	message: "Please enter RIT/INC/Change Number",
			// },
		];

		for (const check of validationChecks) {
			if (check.condition) {
				toastRef.current.show({
					severity: "error",
					summary: "Error",
					detail: check.message,
					life: 3000,
				});
				return;
			}
		}

		if (jobType === "Execute") {
			setSelectedDateTime(null);
		}

		const selectedStores = Object.keys(storeSelectionList).filter(
			(store) => storeSelectionList[store].isSelected
		);
		const selectedDivisions = selectedStores.map(
			(store) => storeSelectionList[store].division
		);
		const serverTypes = serverTypeList;
		const commandToSend =
			selectedCommand === "Install / Update" ? "Update" : selectedCommand;
		const payload = {
			jobId: jobId,
			division: [...new Set(selectedDivisions)],
			stores: selectedStores,
			serverTypes: serverTypes,
			services: service,
			command: commandToSend,
			scheduleDateTime: selectedDateTime,
			forceUpdate: forceUpdate,
			jobType: jobType,
			itsmId: ritNumber,
		};
		dispatch(resepostCreateJobInit(payload));
		setJobPayload(payload);
	};


	const handleDialogClose = () => {
		setShowExistingJobInfoDialog(false);
		setShowConfirmPopUp(true);
	};

	const handleSearch = () => {
		scrollToShowEnteredStore();
	};

	const scrollToShowEnteredStore = () => {
		let enteredStoreNumberIndex = 0;
		if (!!enteredStoreNumber) {
			Object.keys(storeSelectionList)
				.sort((a,b) => a.localeCompare(b))
				.forEach((store, index) => {
					if (store === enteredStoreNumber) {
						enteredStoreNumberIndex = index;
					}
				});
			setFirst(enteredStoreNumberIndex);
		}
	};

	const handleSearchInputChange = (e) => {
		setEnteredStoreNumber(e.target.value);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			handleSearch();
		}
	};

	const handleJobTypeChange = (jobType) => {
		setJobType(jobType);

		if (jobType === "Execute") {
			setSelectedDateTime(null);
		}
	};

	const handleToggleModelContainer = () => {
		setIsModelContainerExpanded(!isModelContainerExpanded);
	};

	const onPageChange = (event) => {
		setFirst(event.first);
		setRows(event.rows);
	};

	/**
	 * Class name functions for store and server
	 */

	  const getStoreClass = (store, storeSelectionList, enteredStoreNumber) => {
		if (storeSelectionList[store].isSelected) {
		  return "store-btn enabled-store";
		} else if (enteredStoreNumber === store) {
		  return "store-btn default-store highlighted-searched-store";
		} else {
		  return "store-btn default-store";
	  	}
	};

	//  Disablement functions

	const areStoresSelected = (storeSelectionList) => {
		return !Object.keys(storeSelectionList || {}).every(
			(store) => !storeSelectionList[store].isSelected
		);
	};

	const isDivisionSelected = !!division;
	const storesSelected = areStoresSelected(storeSelectionList);
	const isServiceTypeSelected = !!service && service.length > 0;
	const isCommandSelected = !!selectedCommand;
	const isJobTypeSelected = !!jobType;

	const isServiceTypeDisabled = !isDivisionSelected || !storesSelected;
	const isActionDisabled = !isDivisionSelected || !storesSelected || !isServiceTypeSelected;
	const isJobTypeDisabled = !isDivisionSelected || !storesSelected || !isServiceTypeSelected || !isCommandSelected;
	const isRITNumberDisabled = !isDivisionSelected || !storesSelected || !isServiceTypeSelected || !isCommandSelected || !isJobTypeSelected;
	const isCreateJobDisabled = !isDivisionSelected || !storesSelected || !isServiceTypeSelected || !isCommandSelected || !isJobTypeSelected;

	return (
		<div className="create-rese-job-container">
			<Dialog
				visible={showExistingJobInfoDialog}
				onHide={handleDialogClose}
				style={{ width: "50vw" }}
				header={`${selectedJobInfo?.jobData}`}
			>
				{selectedJobInfo && (
					<div className="server-info-container">
						{selectedJobInfo?.serverData.map(
							(serverEntry) => (
								<div key={serverEntry} className="server-entry">
									{serverEntry}{" "}
								</div>
							)
						)}
					</div>
				)}
			</Dialog>
			<Dialog
				visible={legendContainer}
				onHide={() => setLegendContainer(false)}
				position="top"
			>
				<div className="color-legend">
					<div className="store-legend">
						<span className="stores-legend-div">
							<span className="stores-legend"></span>
							<span>Unselected Store</span>
						</span>
						<span className="selected-store-div">
							<span className="selected-store-legend"></span>
							<span>Selected Store</span>
						</span>
					</div>
				</div>
			</Dialog>
			<div className="dropdown-container">
				<div className="division-dropdown">
					<span>Division</span>
					<MultiSelect
						optionLabel="division"
						options={divisionList}
						value={division}
						onChange={(event) => {
							setDivision(event.value);
							setStoreSelectionList(null);
							setSelectedServerType(null);
						}}
						disabled={!!resemodifyJobDetails || !!resecloneJobDetails}
						placeholder="All"
						filter
					/>
				</div>
			</div>
			<div
				className={`rese-command-main ${
					isModelContainerExpanded ? "" : "collapsed"
				}`}
			>
				<div className="store-container">
					{storeSelectionList && (
						<>
							<strong>Selected Stores: </strong>
							<span>
								{Object.keys(storeSelectionList)
									.filter(
										(store) =>
											storeSelectionList[store].isSelected
									)
									.slice(0, 9)
									.map((store) => (
										<Chip
											key={store}
											label={store}
											style={{ margin: "0.5rem" }}
										/>
									))}
							</span>
						</>
					)}
					{storeSelectionList &&
						Object.keys(storeSelectionList).filter(
							(store) => storeSelectionList[store].isSelected
						).length >= 10 && (
							<>
								<Tooltip target=".more" />
								<Chip
									label="..."
									className="more"
									data-pr-tooltip={Object.keys(
										storeSelectionList
									)
										.filter(
											(store) =>
												storeSelectionList[store]
													.isSelected
										)
										.slice(9)}
									data-pr-position="right"
								/>
							</>
						)}
					{storeSelectionList && (
						<div className="store-container-top">
							<div className="update-store-selection">
								<Button
									label="Select All Stores"
									onClick={() =>
										handleAllStoreSelection(true)
									}
								/>
								<Button
									label="Reset"
									onClick={() =>
										handleAllStoreSelection(false)
									}
								/>
								<div className="search-store">
									<InputText
										type="text"
										placeholder="Search Store"
										ref={searchInputRef}
										value={enteredStoreNumber || ""}
										onChange={handleSearchInputChange}
										onKeyDown={handleKeyDown}
									/>
									<Button
										label="Search"
										icon="pi pi-search"
										onClick={handleSearch}
										setEnteredStoreNumber={
											enteredStoreNumber
										}
										className="filter-button p-button-outlined p-button-sm"
									/>
								</div>
							</div>
						</div>
					)}

					{storeSelectionList &&
						Object.keys(storeSelectionList)
							.sort((a,b) => a.localeCompare(b))
							.slice(first, first + rows)
							.map((store) => (
								<Button
									key={store}
									ref={(ref) =>
										(storeRowRefs.current[store] = ref)
									}
									label={
										<div>
											<span>{store}</span>
										</div>
									}
									onClick={() =>
										handleStoreButtonClick(store)
									}
									className={getStoreClass(store, storeSelectionList, enteredStoreNumber)}
								/>
							))}
					<Paginator
						first={first}
						rows={rows}
						onPageChange={onPageChange}
						totalRecords={
							!!storeSelectionList &&
							Object.keys(storeSelectionList).length
						}
						rowsPerPageOptions={[15, 25, 50]}
					></Paginator>
				</div>

				<div
					className={`model-container ${
						isModelContainerExpanded ? "expanded" : "collapsed"
					}`}
				>
					<div className="service-dropdown">
						<span style={{ fontWeight: "bold", fontSize: "14px" }}>
							Service(s)
						</span>

						<MultiSelect
							id="service"
							options={availableServices}
							value={service || []}
							data-testid="service-type-multiselect"
							onChange={(e) => {
								setService(e.value);
							}}
							style={{ width: "70%" }}
							disabled={isServiceTypeDisabled}
							placeholder="Select Service(s)"
						/>
					</div>

					<div className="service-dropdown">
						<span style={{ fontWeight: "bold", fontSize: "14px" }}>
							Action
						</span>
						<Dropdown
							optionLabel="action"
							optionValue="action"
							options={[
								{ action: "Start (Set Automatic)" },
								{ action: "Stop (Set Manual)" },
								{ action: "Restart" },
								{ action: "Start"},
								{ action: "Stop"},
								{ action: "Get Status" },
								{ action: "Set Manual" },
								{ action: "Set Automatic" },
								{ action: "Uninstall" },
								{ action: "Install / Update" }

							]}
							value={selectedCommand}
							style={{ width: "70%" }}
							onChange={(event) => {
								setSelectedCommand(event.value);
							}}
							disabled={isActionDisabled}
						/>
					</div>

					<table>
						<thead>
							<tr>
								<th style={{ width: "52%",fontSize:"14px" }}>
									Choose Job Type
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<RadioButton
										inputId="executeNow"
										name="executionOption"
										value="Execute"
										disabled={isJobTypeDisabled}
										onChange={() =>
											handleJobTypeChange("Execute")
										}
										checked={jobType === "Execute"}
									/>
									<label htmlFor="executeNow">
										Execute Now
									</label>
								</td>

								<td>
									<RadioButton
										inputId="schedule"
										name="executionOption"
										value="Scheduled"
										disabled={isJobTypeDisabled}
										onChange={(e) => setJobType(e.value)}
										checked={jobType === "Scheduled"}
									/>
									<label htmlFor="schedule">
										Schedule Later
									</label>
									{jobType === "Scheduled" && (
										<Calendar
											// id="time24"
											testid="date-time-picker"
											minDate={addDateTime("minutes", 10, new Date())}
											value={selectedDateTime}
											// className="division-dropdown"
											onChange={(e) =>
												setSelectedDateTime(e.value)
											}
											style={{ paddingTop: "0.5rem" }}
											disabled={isJobTypeDisabled}
											showIcon
											showTime
										/>
									)}
								</td>
							</tr>
						</tbody>
					</table>

					<div>
						<span style={{ fontWeight: "bold", fontSize: "14px" }}>
							{" "}
							RIT/INC/Change Number{" "}
						</span>
						<InputText
							value={ritNumber}
							onChange={(e) => setRitNumber(e.target.value)}
							disabled={isRITNumberDisabled}
						/>
					</div>

					{storeSelectionList && (
						<Button
							label={
								!resemodifyJobDetails ? "Create Job" : "Modify Job"
							}
							className="submit-btn"
							ref={createJobBtnRef}
							onClick={(event) =>
								confirmPopup({
									target: event.currentTarget,
									icon: "pi pi-info-circle",
									message: !resemodifyJobDetails
										? "Do you want to create this job?"
										: "Do you want to modify this job?",

									accept: () => handleCreateJob(),
								})
							}
							disabled={isCreateJobDisabled}
						/>
					)}
				</div>
				<Button
					icon={`pi pi-arrow-${
						isModelContainerExpanded ? "right" : "left"
					}`}
					className="collapse-button"
					onClick={handleToggleModelContainer}
				></Button>
			</div>

			<ConfirmPopup
				visible={showConfirmPopUp}
				onHide={() => setShowConfirmPopUp(false)}
			/>
			<ConfirmDialog />
			<Toast ref={toastRef} position="bottom-center" />
		</div>
	);
};

export default RESECommandCreateJob;
